import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import {TelephoneFill} from '@styled-icons/bootstrap/TelephoneFill';
import {Bus} from '@styled-icons/fa-solid/Bus';
import {Car} from '@styled-icons/boxicons-solid/Car';
import AboutPinbarBanner from '../../../static/images/about-pinbar-banner.png';
import BrandIntro from '../../../static/images/brand-introduction.png';
import ServiceFlow from '../../../static/images/service-flow.png';
import {CONTACT} from '../../constants';
import FixedRatioImage from '../../Components/FixedRatioImage';

function About(props) {
  const [actions] = useOutlet('actions');
  const [dimension] = useOutlet('dimension');

  return (
    <Wrapper rwd={dimension.rwd} dimension={dimension}>
      <FixedRatioImage
        width="100%"
        ratio="140/489"
        image={AboutPinbarBanner}
        alt="about-pinbar-banner"
        mode="cover"
      />

      <div id="intro">
        <FixedRatioImage
          width="100%"
          ratio="221/361"
          image={BrandIntro}
          alt="brand-intro-image"
          mode="cover"
        />
      </div>

      <div id="service-flow">
        <FixedRatioImage
          width="100%"
          ratio="13/18"
          image={ServiceFlow}
          alt="service-flow-image"
          mode="cover"
        />
      </div>
      <div id="contact" className="offset-anchor">
        <section className="contact section-dark">
          <div className="subtitle">CONTACT</div>
          <div className="title">聯絡Pinbar</div>
          <div className="contact-content" style={{marginTop: 20}}>
            <div style={{flex: 1, padding: 20}}>
              <div className="row">
                <TelephoneFill size={30} />
                <div style={{marginLeft: 12, flex: 1}}>
                  <div className="title">電話{CONTACT.address && '與位置'}</div>
                  <p className="content" style={{marginTop: 20}}>
                    <a
                      href={'tel:' + CONTACT.phone[1]}
                      style={{textDecoration: 'none', color: 'black'}}>
                      {CONTACT.phone[0]}
                    </a>
                  </p>
                  {CONTACT.address && (
                    <p className="content">{CONTACT.address}</p>
                  )}
                </div>
              </div>

              <div className="row" style={{marginTop: 40}}>
                <Bus size={30} />
                <div style={{marginLeft: 12, flex: 1}}>
                  <div className="title">大眾運輸</div>
                  <p className="content" style={{marginTop: 20}}>
                    {`可搭乘捷運「松山新店線(3號線)」至台北小巨蛋站後，2號出口即達。
如搭乘捷運其他路線，可至臺北捷運公司網站【路網圖及各站資訊】中查詢轉乘資訊。`}
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop: 40}}>
                <Car size={30} />
                <div style={{marginLeft: 12, flex: 1}}>
                  <div className="title">開車路線</div>
                  <p className="content" style={{marginTop: 20}}>
                    {`國道1號(中山高速公路)：

北上建議出口：於圓山交流道(建國北路出口)下匝道，走建國北路左轉南京東路4段即可抵達。

南下建議出口：於內湖交流道(南京東路出口)下匝道，走南京東路6段接麥帥一橋，直走南京東路5段至4段即可抵達。

國道3號(福爾摩沙高速公路)：

北上建議出口：安坑交流道(朝台北方向)下匝道，走環河路，接水源快速道路及基隆路高架道路，下敦化南路匝道，左轉直走敦化南北路至南京東路4段即可抵達。

南下建議出口：木柵交流道(朝台北方向)接國道3甲下匝道，接基隆路，左轉直走敦化南北路至南京東路4段即可抵達。`}
                  </p>
                </div>
              </div>
            </div>
            <div style={{flex: 1}}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14456.618019067866!2d121.5166211!3d25.0627519!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x185e3b593090cfcb!2z5aWV5p6c6Zuy56uv5pW45L2N6IKh5Lu95pyJ6ZmQ5YWs5Y-4IChFY3VsdHVyZVRlY2gp!5e0!3m2!1szh-TW!2stw!4v1639100253405!5m2!1szh-TW!2stw"
                width="100%"
                height="100%"
                style={{border: 0}}
                allowFullScreen={true}
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  & > .banner {
    width: 100%;
    height: 600px;
  }
  & > .offset-anchor {
    padding-top: 50px;
    margin-top: -50px;
    & > .contact {
      background-color: #f9f8f7;
      padding: var(--sectionPadding);
      & > .contact-content {
        display: flex;
        flex-direction: row;
      }
    }
  }
  @media screen and (max-width: 768px) {
    & > .offset-anchor {
      & > .contact {
        padding: var(--sectionMobilePadding);
        & > .contact-content {
          flex-direction: column;
        }
      }
    }
  }
`;

export default About;
